import Vue from "vue";
import Endpoints from "@/share/Endpoints";

export const fetchCheckoutInformation = async ({ commit }, productServiceId) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceCheckout.replace(":productServiceId", productServiceId),
      method: "GET",
    });
    commit("SET_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message,
    };
  }
};

export const createOrder = async ({ commit }, productServiceId) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceCheckoutOrder.replace(":productServiceId", productServiceId),
      method: "POST",
    });
    commit("SET_ORDER", data.order);
    if (data.whOrderExpiration) {
      commit("SET_WH_ORDER_EXPIRATION", data.whOrderExpiration);
    }
    return { status: true, data: data.order };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message,
    };
  }
};

export const getOrder = async ({ commit }, orderId) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceCheckoutOrderById.replace(":orderId", orderId),
      method: "GET",
    });
    commit("SET_ORDER", data.order);
    return { status: true, data: data.order };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message,
    };
  }
};

export const setQuantity = async ({ commit }, { orderId, quantity }) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceCheckoutItems.replace(":orderId", orderId),
      method: "POST",
      data: { quantity },
    });
    commit("SET_ORDER", data.order);
    return { status: true, data: data.order };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message,
    };
  }
};

export const setPaymentInformation = async (
  { commit },
  { orderId, paymentInformation }
) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceCheckoutPayment.replace(":orderId", orderId),
      method: "POST",
      data: { paymentInformation },
    });
    commit("SET_ORDER", data.order);
    return { status: true, data: data.order };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message,
    };
  }
};

export const resetCheckout = ({ commit }) => {
  commit("RESET_CHECKOUT");
};
